const formSelector = "[data-offer-form]";

function counterWrapper(target) {
  if (!target.matches("input, textarea")) return null;
  return target.closest("[data-char-counter]");
}

document.addEventListener("input", (event) => {
  const wrapper = counterWrapper(event.target);
  if (!wrapper) return;

  const count = wrapper.querySelector("[data-char-counter-count]");
  if (count) count.textContent = event.target.value.length;
});

document.addEventListener("input", (event) => {
  if (!event.target.matches("[data-offer-discount]")) return;

  const value = parseInt(event.target.value, 10);
  if (!Number.isNaN(value) && value > 100) event.target.value = "100";
});

document.addEventListener("change", (event) => {
  if (!event.target.matches("[data-offer-type-radio]")) return;

  const form = event.target.closest(formSelector);
  const validity = form && form.querySelector("[data-offer-validity]");
  if (!validity) return;

  const temporary = event.target.value === "temporary";
  validity.classList.toggle("hidden", !temporary);
  validity.querySelectorAll("[data-offer-validity-date]").forEach((input) => {
    input.required = temporary;
  });
});

function photoParts(dropzone) {
  const form = dropzone.closest(formSelector);
  return {
    input: dropzone.querySelector("[data-offer-photo-input]"),
    preview: dropzone.querySelector("[data-offer-photo-preview]"),
    placeholder: dropzone.querySelector("[data-offer-photo-placeholder]"),
    removeFlag: form && form.querySelector("[data-offer-photo-remove]"),
    deleteButton: form && form.querySelector("[data-offer-photo-delete]"),
    retainedPhoto: form && form.querySelector("[data-offer-photo-retained]"),
  };
}

function showPhotoPreview(dropzone, file) {
  const { preview, placeholder, removeFlag, deleteButton, retainedPhoto } = photoParts(dropzone);
  if (!preview || !file) return;

  preview.src = URL.createObjectURL(file);
  preview.classList.remove("hidden");
  if (placeholder) placeholder.classList.add("hidden");
  if (removeFlag) removeFlag.value = "0";
  if (deleteButton) deleteButton.classList.remove("hidden");
  if (retainedPhoto) retainedPhoto.value = "";
}

document.addEventListener("click", (event) => {
  const deleteButton = event.target.closest("[data-offer-photo-delete]");
  if (deleteButton) {
    const form = deleteButton.closest(formSelector);
    const dropzone = form && form.querySelector("[data-offer-dropzone]");
    if (!dropzone) return;

    const { input, preview, placeholder, removeFlag, retainedPhoto } = photoParts(dropzone);
    if (input) input.value = "";
    if (preview) {
      preview.classList.add("hidden");
      preview.removeAttribute("src");
    }
    if (placeholder) placeholder.classList.remove("hidden");
    if (removeFlag) removeFlag.value = "1";
    if (retainedPhoto) retainedPhoto.value = "";
    deleteButton.classList.add("hidden");
    dropzone.focus();
    return;
  }

  const dropzone = event.target.closest("[data-offer-dropzone]");
  if (!dropzone) return;

  const { input } = photoParts(dropzone);
  if (input && event.target !== input) input.click();
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Enter" && event.key !== " ") return;
  const dropzone = event.target.closest("[data-offer-dropzone]");
  if (!dropzone || event.target !== dropzone) return;

  event.preventDefault();
  const { input } = photoParts(dropzone);
  if (input) input.click();
});

["dragenter", "dragover"].forEach((name) => {
  document.addEventListener(name, (event) => {
    const dropzone = event.target.closest("[data-offer-dropzone]");
    if (!dropzone) return;

    event.preventDefault();
    dropzone.classList.add("border-black");
  });
});

document.addEventListener("dragleave", (event) => {
  const dropzone = event.target.closest("[data-offer-dropzone]");
  if (dropzone && !dropzone.contains(event.relatedTarget)) {
    dropzone.classList.remove("border-black");
  }
});

document.addEventListener("drop", (event) => {
  const dropzone = event.target.closest("[data-offer-dropzone]");
  if (!dropzone) return;

  event.preventDefault();
  dropzone.classList.remove("border-black");

  const files = event.dataTransfer && event.dataTransfer.files;
  const { input } = photoParts(dropzone);
  if (!input || !files || !files.length) return;

  input.files = files;
  showPhotoPreview(dropzone, files[0]);
});

document.addEventListener("change", (event) => {
  if (!event.target.matches("[data-offer-photo-input]")) return;

  const dropzone = event.target.closest("[data-offer-dropzone]");
  const file = event.target.files && event.target.files[0];
  if (dropzone && file) showPhotoPreview(dropzone, file);
});
